define('flight-components/Hero',[
  'App',
  'flight/lib/component',
  'URIjs/URI',
  'components/owlcarousel/owl-carousel/owl.carousel'
],

function(App, defineComponent, URI){

  var uiHero = function uiHero() {

    this.defaultAttrs({

    });

    this.logBillboardView = function(owl) {

      // get the currently displayed billboard element
      var $currentBillboard = $(owl.owl.owlItems).eq(owl.owl.currentItem).find('.billboard');

      // check if billboard was already logged
      if (!$currentBillboard.data('wasLogged')) {

        // parse billboard data
        var billboard = $currentBillboard.data();

        // set flag so we only log once
        $currentBillboard.data('wasLogged', true);

        // set stringified billboard data on App global (for DTM)
        App.dtmBillboard = JSON.stringify(billboard);

        // manually trigger DTM rule
        this.trigger(document, 'ui-track-event', {name: 'billboardUpdate'});
      }
    };



    this.after('initialize', function() {

      var self = this;

      // Init billboard carousel
      this.$node.owlCarousel({
        singleItem: true,
        stopOnHover: true,
        autoPlay: true,
        lazyLoad: true,

        // Callback fired on init
        afterInit: function() {
          self.logBillboardView(this);
        },

        // Callback fired when carousel changes
        afterMove: function() {
          self.logBillboardView(this);
        }
      });

    });

  }

  return defineComponent(uiHero);

});

